import { useNavigate } from 'react-router-dom';
import { apiClient } from '@/lib/apiClient';
import { useAuthStore } from '@/store/authStore';

/** Shared by the md+ account menu and the phone More sheet. */
export function useLogout(): () => Promise<void> {
    const reset = useAuthStore((s) => s.reset);
    const navigate = useNavigate();
    return async () => {
        try {
            await apiClient.post('/auth/logout');
        } catch {
            // Token may already be invalid - still clear local state.
        } finally {
            reset();
            navigate('/login', { replace: true });
        }
    };
}
